$(document).ready(() => {
  totalPercent();

  $("div#portfolioPercent :input").keyup(function () {
    totalPercent();
  });

  function totalPercent() {
    let total = 0;

    $("div#portfolioPercent :input").each(function () {
      total += Number($(this).val());
    });

    $("#percentSum").val(total);
  }
});
